export default __webpack_public_path__ + "351732e41d43842319969b45c4a49cbc.svg";